<template>
  <header class="site-header">
    <div class="site-header-inner">
      <button class="logo-button" type="button" @click="$router.push({ name: 'home' })">
        <img src="@/assets/logo.png" alt="buybuy GENUINE">
      </button>
      <nav class="main-nav">
        <div class="nav-item-wrap">
          <button :class="['nav-item', active === 'catalogue' ? 'active' : '']" type="button"
            @click="$router.push({ name: 'catalogue' })">
            <span>Parts Catalogues</span>
            <i :class="['el-icon-arrow-down', 'arrow-icon', { open: brandDropdownOpen }]"
              @click.stop="toggleBrandDropdown"></i>
          </button>
          <div v-if="brandDropdownOpen" class="brand-dropdown" ref="brandDropdown">
            <div v-if="brandLoading" class="brand-dropdown-loading">Loading...</div>
            <template v-else>
              <button v-for="brand in brands" :key="brand.id" type="button" class="brand-dropdown-item"
                @click="selectBrand(brand)">
                {{ brand.name }}
              </button>
            </template>
          </div>
        </div>
        <button :class="['nav-item', active === 'inquiry' ? 'active' : '']" type="button"
          @click="$router.push({ name: 'inquiry' })">Make inquiry</button>
        <button :class="['nav-item', active === 'about' ? 'active' : '']" type="button"
          @click="$router.push({ name: 'about' })">About Us</button>
      </nav>
      <div class="header-search">
        <input v-model="searchKeyword" placeholder="Search by part number" type="text" @keyup.enter="handleSearch">
        <button type="button" @click="handleSearch">
          <i class="el-icon-search"></i>
        </button>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'SiteHeader',
  props: {
    active: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      brandDropdownOpen: false,
      brandLoading: false,
      brands: [],
      searchKeyword: ''
    }
  },
  beforeDestroy() {
    this.removeDocumentListener()
  },
  methods: {
    async toggleBrandDropdown() {
      this.brandDropdownOpen = !this.brandDropdownOpen
      if (this.brandDropdownOpen) {
        this.$nextTick(this.addDocumentListener)
        await this.loadBrands()
      } else {
        this.removeDocumentListener()
      }
    },
    async loadBrands() {
      if (this.brands.length || this.brandLoading) return
      this.brandLoading = true
      try {
        const res = await this.$api({
          url: 'Catalog/brandList',
          method: 'get'
        })
        this.brands = res.data || []
      } catch (e) {
        this.$message.error('Failed to load brands')
      } finally {
        this.brandLoading = false
      }
    },
    selectBrand(brand) {
      this.brandDropdownOpen = false
      this.removeDocumentListener()
      this.$router.push({ name: 'catalogue', query: { brand_id: brand.id } })
    },
    onDocumentClick(e) {
      if (!this.$refs.brandDropdown) return
      if (!this.$refs.brandDropdown.contains(e.target) && !e.target.classList.contains('arrow-icon')) {
        this.brandDropdownOpen = false
        this.removeDocumentListener()
      }
    },
    addDocumentListener() {
      document.addEventListener('click', this.onDocumentClick)
    },
    removeDocumentListener() {
      document.removeEventListener('click', this.onDocumentClick)
    },
    handleSearch() {
      const keyword = this.searchKeyword.trim()
      if (this.$route.name === 'catalogue') {
        this.$root.$emit('header-search', keyword)
      } else {
        const query = {}
        if (keyword) {
          query.keyword = keyword
        }
        this.$router.push({ name: 'catalogue', query })
      }
    }
  }
}
</script>

<style scoped>
.site-header {
  width: 100%;
  background: #f3f3f3;
}

.site-header-inner {
  max-width: 1100px;
  height: 88px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 170px 1fr 280px;
  align-items: center;
  gap: 24px;
}

.logo-button {
  border: 0;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 0;
}

.logo-button img {
  width: 126px;
  height: auto;
  display: block;
}

.main-nav {
  display: flex;
  align-items: center;
  gap: 24px;
}

.nav-item {
  border: 0;
  background: transparent;
  color: #666;
  cursor: pointer;
  font-size: 20px;
  line-height: 1;
}

.nav-item {
  height: 48px;
  padding: 0 24px;
  border-radius: 24px;
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}

.nav-item.active,
.nav-item:hover {
  background: #e9e9e9;
  color: #F34B01;
}

.nav-item-wrap {
  position: relative;
}

.arrow-icon {
  cursor: pointer;
  transition: transform 0.2s ease;
  padding: 4px;
}

.arrow-icon.open {
  transform: rotate(180deg);
}

.brand-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 8px;
  min-width: 200px;
  max-height: 360px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
  padding: 6px 0;
  z-index: 100;
}

.brand-dropdown-loading {
  padding: 14px 20px;
  color: #999;
  font-size: 14px;
  text-align: center;
}

.brand-dropdown-item {
  display: block;
  width: 100%;
  border: 0;
  background: transparent;
  text-align: left;
  padding: 10px 20px;
  color: #333;
  font-size: 15px;
  cursor: pointer;
  line-height: 1.4;
}

.brand-dropdown-item:hover {
  background: #f7f7f7;
  color: #F34B01;
}

.header-search {
  height: 46px;
  display: flex;
}

.header-search input {
  flex: 1;
  min-width: 0;
  border: 1px solid #d0d0d0;
  border-right: 0;
  padding: 0 16px;
  color: #333;
  font-size: 18px;
  outline: none;
  background: #fff;
}

.header-search input::placeholder {
  color: #c8c8c8;
}

.header-search button {
  width: 46px;
  border: 0;
  background: #F34B01;
  color: #fff;
  cursor: pointer;
  font-size: 24px;
}

@media (max-width: 980px) {
  .site-header-inner {
    height: auto;
    padding: 18px 20px;
    grid-template-columns: 1fr;
    gap: 18px;
  }

  .main-nav {
    gap: 18px;
    flex-wrap: wrap;
  }

  .header-search {
    max-width: 460px;
  }
}
</style>